<template>
  <a-modal :visible="visible" width="1040px" :footer="null" @cancel="handleCancel">
    <template slot="title">
      <span>配置确认内容</span>
      <span style="margin-left: 8px; color: rgba(0, 0, 0, 0.45); font-size: 12px; font-weight: normal">当前展示为流程中已确认的配置, 实际配置以Apollo配置为准</span>
    </template>
    <div class="config-confirm-modal">
      <a-tabs v-model="selectedEnv" size="small" @change="handleEnvChange">
        <a-tab-pane v-for="env in envOptions" :key="env.value" :tab="env.label">
          <div class="tab-content">
            <div class="filter-section">
              <a-space>
                <template v-for="(filter, index) in filterConfig">
                  <a-select :key="index" v-model="filters[filter.key]" :placeholder="filter.placeholder" style="width: 180px" allow-clear @change="handleFilterChange">
                    <a-select-option v-for="option in getOptions(filter.key)" :key="option" :value="option">
                      {{ option }}
                    </a-select-option>
                  </a-select>
                </template>
              </a-space>
            </div>
            <div class="table-container">
              <a-table :columns="columns" :data-source="filteredData" :loading="loading" :pagination="false" row-key="key" size="middle" class="config-table">
                <template slot="merge_type" slot-scope="text">
                  <a-tag :color="text === 'Add' ? 'green' : 'red'" class="merge-type-tag">
                    {{ text }}
                  </a-tag>
                </template>
              </a-table>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-modal>
</template>

<script>
import { queryConfigConfirmMergeKey } from '@/api/project/workflow';

export default {
  name: 'ConfigConfirmModal',
  props: {
    workflowId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      selectedEnv: 'qa',
      envOptions: [
        { label: 'QA环境', value: 'qa' },
        { label: 'Demo环境', value: 'demo' },
        { label: '生产环境', value: 'prod' }
      ],
      filters: {
        app_id: undefined,
        namespace: undefined,
        merge_key: undefined,
        region: undefined
      },
      filterConfig: [
        { key: 'app_id', placeholder: '选择应用' },
        { key: 'namespace', placeholder: '选择命名空间' },
        { key: 'merge_key', placeholder: '选择键' },
        { key: 'region', placeholder: '选择区域' }
      ],
      rawData: [],
      columns: [
        {
          title: '应用ID',
          dataIndex: 'app_id',
          key: 'app_id',
          width: 240
        },
        {
          title: '命名空间',
          dataIndex: 'namespace',
          key: 'namespace',
          width: 80,
          ellipsis: true
        },
        {
          title: '区域',
          dataIndex: 'region',
          key: 'region',
          width: 100,
          ellipsis: true
        },
        {
          title: '键',
          dataIndex: 'merge_key',
          key: 'merge_key',
          width: 200
        },
        {
          title: '值',
          dataIndex: 'value',
          key: 'value',
          width: 200,
          ellipsis: true
        },
        {
          title: '操作类型',
          dataIndex: 'merge_type',
          key: 'merge_type',
          scopedSlots: { customRender: 'merge_type' },
          width: 80
        }
      ]
    };
  },
  computed: {
    filteredData() {
      return this.rawData.filter(item => {
        return Object.entries(this.filters).every(([key, value]) => !value || item[key] === value);
      });
    }
  },
  methods: {
    getOptions(key) {
      return [...new Set(this.rawData.map(item => item[key]))];
    },
    onOpen() {
      this.visible = true;
      this.fetchData();
    },
    hide() {
      this.visible = false;
    },
    fetchData() {
      this.loading = true;
      queryConfigConfirmMergeKey({
        workflow_id: this.workflowId,
        env: this.selectedEnv.toUpperCase()
      })
        .then(res => {
          this.loading = false;
          this.rawData = res.data.items.map((item, index) => ({
            ...item,
            key: `${item.merge_key}-${item.region}-${index}`
          }));
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleEnvChange() {
      this.fetchData();
    },
    handleFilterChange() {
      // Filtering is handled by computed property
    },
    handleCancel() {
      this.hide();
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-modal-header),
:deep(.ant-modal-body) {
  padding: 16px;
}
.config-confirm-modal {
  .ant-tabs {
    margin-top: -16px;
  }

  .ant-tabs-bar {
    margin-bottom: 12px;
  }

  .tab-content {
    padding: 0;
  }

  .filter-section {
    margin-bottom: 12px;
  }

  .ant-table {
    margin-top: 0;
  }

  .merge-type-tag {
    margin: 0;
    min-width: 50px;
    text-align: center;
  }

  .table-container {
    max-height: 500px;
    overflow-y: auto;
    :deep(.ant-table) {
      .ant-table-thead > tr > th {
        top: 0;
        z-index: 1;
        position: sticky;
        background: #fafafa;
      }
    }
  }

  :deep(.ant-select) {
    .ant-select-selection {
      border-radius: 4px;
    }
  }
}
</style>
